import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppTheme from './styles/theme/AppTheme';
import {
  RouterProvider,
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import { GetRoutes } from './router/Routers';
import { Provider } from 'react-redux';
import { store } from 'store/store';

const router = GetRoutes();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <AppTheme>
    <Provider store={store} >
      <RouterProvider router={router} />
    </Provider>
  </AppTheme>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
